<template>
    <div class="md-layout">
        <div class="md-layout-item md-size-100">
            <md-card class="pl-1 pr-1">
                <md-card-header class="pb-0">
                    <h4 class="title pt-1">Detalhes</h4>
                </md-card-header>
                <md-card-content>
                    <div class="md-layout">
                        <div class="md-layout-item md-size-100">
                            <md-field>
                                <label>Nome</label>
                                <md-input
                                    type="text"
                                    v-model="currentCluster.name"
                                    :disabled="loadingCluster"
                                ></md-input>
                            </md-field>
                        </div>
                        <div class="md-layout-item md-size-100">
                            <md-field>
                                <label for="cluster-type">Tipo</label>
                                <md-select
                                    id="cluster-type"
                                    v-model="currentCluster.cluster_type"
                                >
                                    <md-option
                                        v-for="(clusterType,
                                        index) in clusterTypes"
                                        v-bind:key="`clusterType-${index}`"
                                        :value="clusterType.id"
                                        :title="clusterType.description"
                                    >
                                        {{ clusterType.name }}
                                    </md-option>
                                </md-select>
                            </md-field>
                        </div>
                        <div class="md-layout-item md-size-100">
                            <md-field>
                                <label for="description">Descrição</label>
                                <md-textarea
                                    name="description"
                                    id="description"
                                    v-model="currentCluster.description"
                                    :disabled="loadingCluster"
                                >
                                </md-textarea>
                            </md-field>
                        </div>

                        <div class="md-layout-item md-size-100 text-right mt-1">
                            <md-button
                                class="md-simple md-sm"
                                @click="readCurrentCluster()"
                                :disabled="loadingCluster"
                            >
                                Cancelar
                            </md-button>
                            <md-button
                                class="md-primary md-sm ml-1"
                                @click="saveCurrentCluster()"
                                :disabled="loadingCluster"
                            >
                                Salvar
                            </md-button>
                        </div>
                    </div>
                </md-card-content>
            </md-card>
        </div>

        <div class="md-layout-item md-size-100">
            <md-card>
                <md-card-header>
                    <div style="text-align: right">
                        <md-button
                            class="md-primary md-sm"
                            style="margin: 20px 20px 0 20px"
                            @click.native="branchesOpen()"
                            :disabled="loadingCluster"
                        >
                            Gerenciar lojas
                        </md-button>
                        <md-button
                            class="md-just-icon md-simple"
                            style="float:right; margin: 10px 0 0 0"
                            @click.native="handleColumnsEdit()"
                        >
                            <md-icon>settings</md-icon>
                        </md-button>
                    </div>
                </md-card-header>
                <md-card-content>
                    <md-table
                        :value="queriedData.results"
                        :md-sort.sync="currentSort"
                        :md-sort-order.sync="currentSortOrder"
                        :md-sort-fn="customSort"
                        class="paginated-table table-striped table-hover"
                    >
                        <md-table-row slot="md-table-row" slot-scope="{ item }">
                            <md-table-cell
                                v-for="column in visibleColumns"
                                :md-label="columnNames[column]"
                                :md-sort-by="column"
                                :key="column"
                                :title="item[column]"
                            >
                                {{ item[column] }}
                            </md-table-cell>
                            <md-table-cell md-label="Ações">
                                <md-button
                                    class="md-just-icon md-danger md-simple"
                                    @click.native="handleDelete(item)"
                                >
                                    <md-icon>close</md-icon>
                                </md-button>
                            </md-table-cell>
                        </md-table-row>
                    </md-table>
                </md-card-content>
                <md-card-actions md-alignment="space-between">
                    <div class="">
                        <p class="card-category">
                            Mostrando itens {{ from }} a {{ to }} de um total de
                            {{ total }}.
                        </p>
                    </div>
                    <pagination
                        class="pagination-no-border pagination-success"
                        v-model="pagination.currentPage"
                        :per-page="pagination.perPage"
                        :total="total"
                    >
                    </pagination>
                </md-card-actions>
            </md-card>
        </div>

        <form @submit.prevent="branchesSubmit()">
            <modal v-if="branchesModal" @close="branchesCancel()" width="500px">
                <template slot="header">
                    <h4 class="modal-title">Selecionar filiais</h4>
                    <md-button
                        class="md-simple md-just-icon md-round modal-default-button"
                        @click="branchesCancel()"
                    >
                        <md-icon>clear</md-icon>
                    </md-button>
                </template>

                <template slot="body">
                    <div class="md-layout">
                        <div class="md-layout-item md-size-100">
                            <md-card>
                                <md-card-header class="pb-0">
                                    <h4 class="title pt-1">Pesquisar</h4>
                                </md-card-header>
                                <md-card-content>
                                    <div class="md-layout">
                                        <div class="md-layout-item md-size-33">
                                            <md-field>
                                                <label>Filial</label>
                                                <md-input
                                                    type="text"
                                                    v-model="
                                                        branchesFilter.name
                                                    "
                                                    :disabled="loadingCluster"
                                                ></md-input>
                                            </md-field>
                                        </div>
                                        <div class="md-layout-item md-size-33">
                                            <md-field>
                                                <label>Cidade</label>
                                                <md-input
                                                    type="text"
                                                    v-model="
                                                        branchesFilter.city
                                                    "
                                                    :disabled="loadingCluster"
                                                ></md-input>
                                            </md-field>
                                        </div>
                                        <div class="md-layout-item md-size-33">
                                            <md-field>
                                                <label>Estado</label>
                                                <md-input
                                                    type="text"
                                                    v-model="
                                                        branchesFilter.state
                                                    "
                                                    :disabled="loadingCluster"
                                                ></md-input>
                                            </md-field>
                                        </div>

                                        <div
                                            class="md-layout-item md-size-100 text-right mt-1"
                                        >
                                            <md-button
                                                class="md-simple md-sm"
                                                @click="resetBranchesFilter()"
                                                :disabled="
                                                    loadingBranches ||
                                                        loadingCluster
                                                "
                                            >
                                                Limpar
                                            </md-button>
                                            <md-button
                                                class="md-primary md-sm ml-1"
                                                @click="readBranchNameIds()"
                                                :disabled="
                                                    loadingBranches ||
                                                        loadingCluster
                                                "
                                            >
                                                Pesquisar
                                            </md-button>
                                        </div>
                                    </div>
                                </md-card-content>
                            </md-card>
                        </div>
                        <div class="md-layout-item md-size-100">
                            <div v-if="loadingBranches">Carregando...</div>
                            <md-table
                                v-else
                                md-card
                                md-fixed-header
                                :mdSelectedValue="selectedBranches"
                                id="clusterBranchSelect"
                                class="table-striped table-hover text-left"
                                :value="branchNameIds"
                                @md-selected="onSelect"
                            >
                                <md-table-toolbar>
                                    <h1 class="md-title">
                                        Filiais
                                    </h1>
                                </md-table-toolbar>
                                <md-table-toolbar
                                    slot="md-table-alternate-header"
                                    slot-scope="{ count }"
                                >
                                    <div class="md-toolbar-section-start">
                                        {{ getAlternateLabel(count) }}
                                    </div>

                                    <div class="md-toolbar-section-end">
                                        <md-button
                                            class="md-icon-button"
                                            @click="selectedBranches = []"
                                        >
                                            <md-icon>delete</md-icon>
                                        </md-button>
                                    </div>
                                </md-table-toolbar>
                                <md-table-row
                                    slot="md-table-row"
                                    slot-scope="{ item }"
                                    md-selectable="multiple"
                                    md-auto-select
                                >
                                    <md-table-cell md-label="Filial">
                                        {{ item.number }} - {{ item.name }}
                                    </md-table-cell>
                                </md-table-row>
                            </md-table>
                        </div>
                    </div>
                </template>

                <template slot="footer">
                    <md-button class="md-simple" @click="branchesCancel()">
                        Cancelar
                    </md-button>
                    <md-button
                        class="md-primary"
                        type="submit"
                        :disabled="loadingCluster || loadingBranches"
                    >
                        Salvar
                    </md-button>
                </template>
            </modal>
        </form>

        <modal v-if="columnsModal" @close="columnsCancel()" width="250px">
            <template slot="header">
                <h4 class="modal-title">Colunas disponíveis</h4>
                <md-button
                    class="md-simple md-just-icon md-round modal-default-button"
                    @click="columnsCancel()"
                >
                    <md-icon>clear</md-icon>
                </md-button>
            </template>

            <template slot="body">
                <div style="text-align: left">
                    <md-checkbox
                        v-for="column in Object.keys(showColumns)"
                        v-model="showColumns[column]"
                        :key="column"
                    >
                        {{ columnNames[column] }}
                    </md-checkbox>
                </div>
            </template>

            <template slot="footer">
                <md-button class="md-primary" @click="columnsCancel()">
                    OK
                </md-button>
            </template>
        </modal>
    </div>
</template>

<script>
import { Pagination, Modal } from '@/components'
import Swal from 'sweetalert2'
import { mapState, mapActions } from 'vuex'

import { Branch as Model } from '@/models/branch.model'
const model = 'branches'

export default {
    created() {
        if (!this.$route.params.id || isNaN(Number(this.$route.params.id)))
            this.$router.push('/clusters')
        this.clusterId = Number(this.$route.params.id)
        this.readCurrentCluster()
        this.readClusterTypes()
        this.readBranches({ cluster: this.clusterId })
    },
    components: {
        Pagination,
        Modal
    },
    computed: {
        ...mapState({
            currentCluster: state => state['clusters'].currentCluster,
            clusterTypes: state => state['clusters'].clusterTypes,
            queriedData: state => state['branches'].page,
            _branchNameIds: state => state['branches'].nameIds
        }),
        to() {
            if (this.queriedData.results.length > 0)
                return this.queriedData.results[
                    this.queriedData.results.length - 1
                ].id
            else return 0
        },
        from() {
            if (this.queriedData.results.length > 0)
                return this.queriedData.results[0].id
            else return 0
        },
        total() {
            return this.queriedData.count
        },
        visibleColumns() {
            let columns = []
            Object.keys(this.showColumns).forEach(key => {
                if (this.showColumns[key]) columns.push(key)
            })
            return columns
        },
        branchNameIds() {
            return this._branchNameIds.slice(1) // remove "Todas" from the list
        }
    },
    data() {
        return {
            clusterId: null,
            loadingCluster: false,

            branchesModal: false,
            loadingBranches: false,
            selectedBranches: [],
            branchesFilter: {
                name: null,
                city: null,
                state: null
            },

            columnsModal: false,

            showColumns: {
                number: true,
                name: true,
                state: true,
                city: true
            },
            columnNames: Model.fieldNames,
            currentSort: 'id',
            currentSortOrder: 'asc',
            pagination: {
                perPage: parseInt(process.env.VUE_APP_DEFAULT_PAGE_SIZE),
                currentPage: 1,
                total: 0
            }
        }
    },
    methods: {
        ...mapActions(model, {
            readBranches: 'read',
            _readBranchNameIds: 'readNameIds'
        }),
        ...mapActions('clusters', {
            readCluster: 'read',
            readClusterTypes: 'readClusterTypes',
            updateCluster: 'update',
            deleteClusterBranch: 'deleteBranch'
        }),
        customSort(value) {
            return value.sort((a, b) => {
                const sortBy = this.currentSort
                try {
                    if (this.currentSortOrder === 'desc')
                        return a[sortBy].localeCompare(b[sortBy])
                    return b[sortBy].localeCompare(a[sortBy])
                } catch (e) {
                    return 0
                }
            })
        },
        handleColumnsEdit() {
            this.columnsModal = true
        },
        columnsCancel() {
            this.columnsModal = false
        },

        viewOpen(item) {
            this.branchesModalModel = { ...this.branchesModalModel, ...item }
            this.viewModal = true
        },
        viewCancel() {
            this.viewModal = false
            this.branchesModalModel = new Model()
        },

        async saveCurrentCluster() {
            this.loadingCluster = true

            let saveError = await this.updateCluster(this.currentCluster)
            if (saveError)
                this.$notify({
                    message: 'Erro ao salvar cluster.',
                    icon: 'add_alert',
                    horizontalAlign: 'right',
                    verticalAlign: 'bottom',
                    type: 'danger'
                })
            else {
                this.$notify({
                    message: 'Cluster salvo com sucesso!',
                    icon: 'add_alert',
                    horizontalAlign: 'right',
                    verticalAlign: 'bottom',
                    type: 'success'
                })
            }

            this.loadingCluster = false
        },
        async readCurrentCluster() {
            this.loadingCluster = true
            await this.readCluster({ id: this.clusterId })
            this.loadingCluster = false
        },

        resetBranchesFilter() {
            this.branchesFilter = {
                name: null,
                city: null,
                state: null
            }
        },
        async readBranchNameIds() {
            this.loadingBranches = true
            await this._readBranchNameIds({
                cluster: this.clusterId,
                ...this.branchesFilter
            })
            this.loadingBranches = false
        },
        async branchesOpen(item) {
            this.branchesModal = true

            await this.readBranchNameIds()
            this.selectedBranches = []
            this.branchNameIds.map(branch =>
                branch.selected ? this.selectedBranches.push(branch) : ''
            )
        },
        branchesCancel() {
            this.branchesModal = false
        },
        async branchesSubmit() {
            this.loadingCluster = true
            let selectedBranchesIds = []
            this.selectedBranches.map(item => selectedBranchesIds.push(item.id))

            let saveError = await this.updateCluster({
                id: this.currentCluster.id,
                branches: selectedBranchesIds
            })
            if (saveError)
                this.$notify({
                    message: 'Erro ao salvar cluster.',
                    icon: 'add_alert',
                    horizontalAlign: 'right',
                    verticalAlign: 'bottom',
                    type: 'danger'
                })
            else {
                this.$notify({
                    message: 'Cluster salvo com sucesso!',
                    icon: 'add_alert',
                    horizontalAlign: 'right',
                    verticalAlign: 'bottom',
                    type: 'success'
                })
                this.readBranches({ cluster: this.clusterId })
            }
            this.loadingCluster = false
            this.branchesModal = false
        },

        handleDelete(item) {
            Swal.fire({
                title: 'Certeza?',
                text: 'Esta ação é irreversível.',
                type: 'warning',
                showCancelButton: true,
                confirmButtonClass: 'md-button md-danger btn-fill',
                cancelButtonClass: 'md-button md-simple',
                confirmButtonText: 'Sim, remover!',
                cancelButtonText: 'Cancelar',
                buttonsStyling: false
            }).then(async result => {
                if (result.value) {
                    let deleteError = await this.deleteClusterBranch({
                        id: this.clusterId,
                        branches_id: item.id
                    })

                    if (deleteError)
                        this.$notify({
                            message: 'Erro ao remover.',
                            icon: 'add_alert',
                            horizontalAlign: 'right',
                            verticalAlign: 'bottom',
                            type: 'danger'
                        })
                    else {
                        this.$notify({
                            message: 'Removido com sucesso!',
                            icon: 'add_alert',
                            horizontalAlign: 'right',
                            verticalAlign: 'bottom',
                            type: 'success'
                        })
                        this.readBranches({ cluster: this.clusterId })
                    }
                }
            })
        },

        onSelect(items) {
            this.selectedBranches = items
        },
        getAlternateLabel(count) {
            return `${count} filia${count > 1 ? 'is' : 'l'} selecionada${
                count > 1 ? 's' : ''
            }`
        }
    },
    watch: {
        pagination: {
            handler: function(val) {
                this.readBranches({ page: val.currentPage })
            },
            deep: true
        }
    }
}
</script>

<style>
#clusterBranchSelect .md-table-head {
    text-align: left;
}
#clusterBranchSelect .md-table-cell {
    padding: 1px 8px;
}
#clusterBranchSelect .md-table-cell-checkbox {
    width: 1px;
}
#clusterBranchSelect .md-checkbox {
    margin: 16px;
}
</style>
<style lang="css" scoped>
textarea {
    padding-left: 0 !important;
}
.md-card .md-card-actions {
    border: 0;
    margin-left: 20px;
    margin-right: 20px;
}
.modal-wrapper .md-checkbox {
    display: flex !important;
}
.md-table-cell {
    max-width: 100px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
